import type { UserInfo } from "@/types/user/userInfo";
import {
  createGraphQLTemplateLayout,
  getGraphQLTemplateLayout,
  listGraphQLTemplateLayouts,
  updateGraphQLTemplateLayout,
} from "./graphqlTemplateLayoutRepository";
import type {
  TemplateLayoutRepository,
  TemplateLayoutRepositoryContext,
} from "./templateLayoutRepository.types";

export interface GetTemplateLayoutRepositoryOptions {
  /** Injected repository; bypasses the GraphQL default (tests and Storybook). */
  repository?: TemplateLayoutRepository;
}

type TemplateLayoutRepositoryUser = Pick<UserInfo, "id"> & {
  default_tenant: Pick<UserInfo["default_tenant"], "id">;
};

export interface ResolveTemplateLayoutRepositorySelectionOptions {
  user: TemplateLayoutRepositoryUser;
  repository?: TemplateLayoutRepository;
  context?: TemplateLayoutRepositoryContext;
}

const graphQLTemplateLayoutRepository: TemplateLayoutRepository = {
  list: listGraphQLTemplateLayouts,
  get: getGraphQLTemplateLayout,
  create: createGraphQLTemplateLayout,
  update: updateGraphQLTemplateLayout,
};

export const getTemplateLayoutRepository = (
  options: GetTemplateLayoutRepositoryOptions = {},
): TemplateLayoutRepository => {
  return options.repository ?? graphQLTemplateLayoutRepository;
};

export const resolveTemplateLayoutRepositoryContext = (
  user: TemplateLayoutRepositoryUser,
): TemplateLayoutRepositoryContext => ({
  tenantId: String(user.default_tenant.id),
  userId: String(user.id),
});

export const resolveTemplateLayoutRepositorySelection = ({
  user,
  repository: repositoryOverride,
  context: contextOverride,
}: ResolveTemplateLayoutRepositorySelectionOptions) => ({
  repository: getTemplateLayoutRepository({ repository: repositoryOverride }),
  context: contextOverride ?? resolveTemplateLayoutRepositoryContext(user),
});
